export default __webpack_public_path__ + "static/media/Artist9.6ce4421e.svg";